import styled from 'styled-components';

import { Text } from '@/shared/uikit/Text';

export const StyledText = styled(Text)`
  &&& {
    color: #fff;
  }
`;

export const Container = styled.div`
  width: fit-content;
  position: relative;
  display: flex;
  flex-direction: column;
  color: #fff;
  align-items: center;
  gap: 8px;
  padding: 6px;
  border-radius: 6px;

  &.active {
    background-color: #787878;
  }
`;
